
import qs from 'qs';
import {parseAuthenticationServerResponseToAuthentication} from './TransformAuthenticationResponse';
import { AcquirerType, IAuthenticationServerResponse } from './IAuthService';
import { HttpRepository } from '../api/_HttpRepository';
import { IHttpRepository } from 'Infrastructure/interfaces/IHttpRepository';

const AuthenticationService = (): IAuthenticationService => {

  const httpRepository: IHttpRepository = HttpRepository();

  const updateAuthentication = async (imei: string, mac: string, terminalId: string): Promise<IAuthenticationDTO> => {
    const data = qs.stringify({
      IMEI: `${imei}`,
      usuarioMeepPOSId: terminalId,
    });

    try {
      const response = await httpRepository.postAsync<any,IAuthenticationServerResponse>("UsuarioMeepPOS/AtualizarDadosEquipamento",
        data,
      );

      return parseAuthenticationServerResponseToAuthentication(response);
    } catch (error) {
      throw error;
    }
  };

  const authenticate = async (
    imei: string,
    mac: string,
    acquirer?: AcquirerType,
    serial?: string,
  ): Promise<IAuthenticationDTO> => {
    const data = {
      IMEI: `${imei}`,
      serial,
      tipoAdquirente: acquirer,
      tipoDispositivo: '1',
      tipoSistemaOperacional: 1,
    };
    
    try {
      const response = await httpRepository.postAsync<any,IAuthenticationServerResponse>(
        'UsuarioMeepPOS/LoginAutomaticoPOS',
        qs.stringify(data),
      );

      return parseAuthenticationServerResponseToAuthentication(response);
    } catch (error) {
      throw error;
    }
  };





  return {
    updateAuthentication,
    authenticate
  };
};

export default AuthenticationService;




export interface IAuthenticationDTO {
    id: string;
    name: string;
    local: IAuthenticationLocalDTO;
    token: string;
  }
  
  export interface IAuthenticationLocalDTO {
    id?: string;
    name?: string;
    imageUrl?: string;
  }
  

  
export interface IAuthenticationService {
  /**
   *@name updateAuthentication
   *@description search on server and update the authentication data
   * @param imei {string} - imei code for login
   * @param mac {string} - mac code for login
   * @param terminalId {string} - terminal code for login
   */
  updateAuthentication(imei: string, mac: string, terminalId: string): Promise<IAuthenticationDTO>;

  /**
   * @name authenticate
   * @description passing imei and mac address to validate if the device is linked with the stablishment
   * @param imei {string} - imei code for login
   * @param mac {string} - mac code for login
   * @param acquirer {AcquirerType} - acquirer type to handle configs from server
   * @param serial {string} - machine serial number for authentication
   */
  authenticate(imei: string, mac: string, acquirer?: AcquirerType, serial?: string): Promise<IAuthenticationDTO>;

}
